(function () {
    'use strict';

    angular.module("imApp").factory("unitService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 602,
                    parameters: parms || {}
                });
            },
            listPropertyClasses: function (parms) {
                return $ihttp.post({
                    method: 604,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 605,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 608,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
